export default __webpack_public_path__ + "static/media/cirec2.06431b48.png";